var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getTokenFromSession } from "./auth.service";
var hostname = window.location.hostname;
var getApiUrl = function (isLead) {
    if (isLead === void 0) { isLead = false; }
    var env = hostname.split('.')[0];
    var apiUrls = {
        'localhost': 'https://localhost:7193/api/', //'https://lecorpapi.nafinc.com/mrkt/dev/api/', //
        'int': 'https://lecorpapi.nafinc.com/mrkt/api/',
        'preprod': 'https://lecorpapi.nafinc.com/mrkt/uat/api/',
        'www': 'https://corpapi.nafinc.com/mrkt/api/', //prod
    };
    var leadBaseUrls = {
        'localhost': 'https://localhost:7111/', // 'https://lecorpapi.nafinc.com/qa/digital/leads/',
        'int': 'https://lecorpapi.nafinc.com/qa/digital/leads/',
        'preprod': 'https://lecorpapi.nafinc.com/qa/digital/leads/',
        'www': 'https://corpapi.nafinc.com/prod/digital/leads/', //prod
    };
    return isLead ? leadBaseUrls[env] : apiUrls[env];
};
var getApiKey = function (isLead) {
    if (isLead === void 0) { isLead = false; }
    var env = hostname.split('.')[0];
    var apiKey = {
        'localhost': "50a7bf3ed3184c41bd45a8f39a31fcd7",
        'int': "9adc26230bb7455c98209ba924ccc034",
        'preprod': "3be2d3cb1a6245f3977d0526c98085ac",
        'www': "1feb9554b65d44949abc4469fa8673d2" //prod
    };
    var apiKeyforLeads = {
        'localhost': "27203227dfdf40c89ec3ecd9a8db0166",
        'int': "27203227dfdf40c89ec3ecd9a8db0166",
        'preprod': "27203227dfdf40c89ec3ecd9a8db0166",
        'www': "b0e27e4b030c4f63baea5a302d512b72" //prod
    };
    return isLead ? apiKeyforLeads[env] : apiKey[env];
};
var apiBaseUrl = getApiUrl();
var apiKey = getApiKey();
var getRequest = function (leadPost) {
    if (leadPost === void 0) { leadPost = false; }
    return ({
        method: 'GET',
        headers: headerOptions(leadPost)
    });
};
export var getResponse = function (endpoint_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([endpoint_1], args_1, true), void 0, function (endpoint, leadPost, request) {
        var req, response, data;
        if (leadPost === void 0) { leadPost = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    req = request || getRequest(leadPost);
                    return [4 /*yield*/, fetch("".concat(getApiUrl(leadPost)).concat(endpoint), req)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    return [2 /*return*/, [data, response.status]];
            }
        });
    });
};
var headerOptions = function (leadPost) {
    if (leadPost === void 0) { leadPost = false; }
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Ocp-Apim-Subscription-Key', "".concat(getApiKey(leadPost)));
    var token = getTokenFromSession();
    if (token) {
        headers.append('authorization', "Bearer ".concat(token));
    }
    return headers;
};
export function getFormConfig(formUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var endpoint, _a, data, status;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endpoint = "dynamicform/getformbyurl?formUrl=".concat(encodeURIComponent(formUrl));
                    return [4 /*yield*/, getResponse(endpoint)];
                case 1:
                    _a = _b.sent(), data = _a[0], status = _a[1];
                    if (status >= 400) {
                        throw new Error("HTTP ".concat(status));
                    }
                    return [2 /*return*/, data];
            }
        });
    });
}
export function submitFormData(formData) {
    return __awaiter(this, void 0, void 0, function () {
        var response, _a, _b, _c, error_1, endpoint, requestOptions, _d, data, status;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    // Log to server for terminal logging (non-blocking)
                    console.log('[API.TS] Attempting to log form data to server:', formData);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch('/api/ReactDfForm/log', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify(formData)
                        })];
                case 2:
                    response = _e.sent();
                    _b = (_a = console).log;
                    _c = ['[API.TS] Server logging response:', response.status];
                    return [4 /*yield*/, response.text()];
                case 3:
                    _b.apply(_a, _c.concat([_e.sent()]));
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _e.sent();
                    console.warn('[API.TS] Server logging failed (non-critical):', error_1);
                    return [3 /*break*/, 5];
                case 5:
                    endpoint = sessionStorage.getItem('postendpoint');
                    if (!endpoint) {
                        endpoint = 'postlead';
                    }
                    requestOptions = {
                        method: 'POST',
                        headers: headerOptions(true),
                        body: JSON.stringify(formData)
                    };
                    return [4 /*yield*/, getResponse(endpoint, true, requestOptions)];
                case 6:
                    _d = _e.sent(), data = _d[0], status = _d[1];
                    return [2 /*return*/, [data, status]];
            }
        });
    });
}
